import { omit } from 'lodash';

/**
 * standardized way of prepping an entity for being sent to the TE API gateway
 */
export function prepEntityForAPICall<T extends object>(
  entity: T,
  removeOrgId: true,
  removeId: true
): Omit<T, 'organizationId' | 'id' | 'createdAt' | 'updatedAt' | 'legacyId'>;
export function prepEntityForAPICall<T extends object>(
  entity: T,
  removeOrgId: false,
  removeId: true
): Omit<T, 'id'>;
export function prepEntityForAPICall<T extends object>(
  entity: T,
  removeOrgId: false
): T;
export function prepEntityForAPICall<T extends object>(
  entity: T,
  removeOrgId: true
): Omit<T, 'organizationId'>;
export function prepEntityForAPICall<T extends object>(
  entity: T
): Omit<T, 'organizationId'>;
export function prepEntityForAPICall<T extends object>(
  entity: T,
  removeOrgId = true,
  removeId = false
):
  | T
  | Omit<T, 'id'>
  | Omit<T, 'organizationId'>
  | Omit<T, 'organizationId' | 'id' | 'createdAt' | 'updatedAt' | 'legacyId'> {
  if (!removeOrgId && !removeId) {
    return entity;
  }

  if (removeOrgId && !removeId) {
    return omit(entity, 'organizationId');
  }

  if (!removeOrgId && removeId) {
    return omit(entity, 'id');
  }

  return omit(entity, [
    'organizationId',
    'id',
    'createdAt',
    'updatedAt',
    'legacyId',
  ]) as Omit<
    T,
    'organizationId' | 'id' | 'createdAt' | 'updatedAt' | 'legacyId'
  >;
}
